(function () {
    const container = document.querySelector('._featured-posts-container');
    const posts = container ? container.querySelectorAll('.featured-post') : [];
    const prevBtn = document.getElementById('fp_prev');
    const nextBtn = document.getElementById('fp_next');

    if (!posts.length || !prevBtn || !nextBtn) return;

    let current = 0;
    let animating = false;

    function setEqualHeight() {
        // Temporarily show all posts off-screen to measure
        posts.forEach(function (p) {
            p.style.minHeight = '';
            p.style.display = 'flex';
            p.style.visibility = 'hidden';
            p.style.position = 'absolute';
        });

        var tallest = 0;
        posts.forEach(function (p) {
            if (p.offsetHeight > tallest) tallest = p.offsetHeight;
        });

        // Reset inline styles and apply min-height
        posts.forEach(function (p) {
            p.style.display = '';
            p.style.visibility = '';
            p.style.position = '';
            p.style.minHeight = tallest + 'px';
        });
    }

    posts[0].classList.add('is-active');
    setEqualHeight();

    var resizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(setEqualHeight, 150);
    });

    function clearClasses(el) {
        el.classList.remove('is-animating', 'slide-in-right', 'slide-in-left', 'slide-out-right', 'slide-out-left');
    }

    function goTo(newIndex, direction) {
        if (animating || newIndex === current) return;
        animating = true;

        const outgoing = posts[current];
        const incoming = posts[newIndex];
        const outClass = direction === 'next' ? 'slide-out-left' : 'slide-out-right';
        const inClass = direction === 'next' ? 'slide-in-right' : 'slide-in-left';

        // Outgoing becomes absolutely positioned so incoming can take the flow
        outgoing.classList.add('is-animating', outClass);
        outgoing.classList.remove('is-active');

        // Incoming takes normal flow and slides in
        incoming.classList.add('is-active', inClass);

        outgoing.addEventListener('animationend', function handler() {
            outgoing.removeEventListener('animationend', handler);
            clearClasses(outgoing);
            clearClasses(incoming);
            incoming.classList.add('is-active');
            current = newIndex;
            animating = false;
        });
    }

    prevBtn.addEventListener('click', function () {
        goTo((current - 1 + posts.length) % posts.length, 'prev');
    });

    nextBtn.addEventListener('click', function () {
        goTo((current + 1) % posts.length, 'next');
    });
})();
